export const PageHead = ({ eyebrow, title, children }) => (
  <div className="mb-10 flex flex-wrap items-end justify-between gap-4 animate-fade-up">
    <div>
      <div className="eyebrow mb-3">{eyebrow}</div>
      <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">{title}</h1>
    </div>
    {children}
  </div>
);

export const Stat = ({ label, value, testid, accent }) => (
  <div data-testid={testid} className="panel relative overflow-hidden p-6 transition-colors duration-300 hover:border-[#ff3b91]/30">
    {accent && <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-[#ff3b91]/20 blur-2xl" />}
    <div className="eyebrow">{label}</div>
    <div className="mt-3 font-display text-3xl font-bold">{value}</div>
  </div>
);

export const Locked = ({ what, children }) => (
  <div data-testid="locked-feature" className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-dashed border-[#ff3b91]/30 bg-[#ff3b91]/[0.04] px-4 py-3 text-sm text-zinc-300">
    <span>{children || `${what} is locked.`}</span>
    <a href="/dashboard/store" className="font-semibold text-[#ff3b91] hover:underline" data-testid="locked-unlock-link">unlock {what} →</a>
  </div>
);
